const api = [
  {
    name: 'status',
    method: 'GET',
    desc: '反馈中心-状态栏',
    path: '/status'
  },
  {
    name: 'list',
    method: 'GET',
    desc: '反馈中心-列表',
    path: '/show/list'
  },
  {
    name: 'type',
    method: 'GET',
    desc: '反馈中心-反馈类型',
    path: '/type'
  },
  {
    name: 'current',
    method: 'GET',
    desc: '反馈中心-反馈详情',
    path: '/current',
    append: true
  },
  {
    name: 'operate',
    method: 'POST',
    desc: '反馈中心-处理反馈',
    path: '/operate'
  },
  {
    name: 'remark',
    method: 'GET',
    desc: '反馈中心-处理反馈常用语',
    path: '/remark'
  }
]

export default {
  BASE_URL: '/crm/feedback',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/feedback/index.js